module.exports = __webpack_public_path__ + "static/media/iamthatiam2.fd31cf50.jpg";